<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p *ngIf="!data.isHtml">{{data.content}}</p>
  <div *ngIf="data.isHtml" [innerHTML]="data.content"></div>
</div>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
